(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-sph-bundle]');
  if(!root)return;
  function money(c){return 'CHF '+(c/100).toFixed(2).replace('.',',');}
  function rows(){return Array.prototype.slice.call(root.querySelectorAll('[data-sph-item]'));}
  function qtyOf(r){
    var q=r.querySelector('[data-sph-qty]');
    var n=q?parseInt(q.value,10):1;
    return isNaN(n)||n<1?1:n;
  }

  function update(){
    var total=0,n=0;
    rows().forEach(function(r){
      var cb=r.querySelector('[data-sph-cb]'),v=r.querySelector('[data-sph-var]'),price=0;
      if(v&&v.tagName==='SELECT'){var o=v.options[v.selectedIndex];price=o?parseInt(o.getAttribute('data-price'),10):0;}
      else if(v){price=parseInt(v.getAttribute('data-price'),10)||0;}
      var q=qtyOf(r);
      r.querySelector('[data-sph-itemp]').textContent=money(price*q);
      if(cb&&cb.checked){total+=price*q;n+=q;}
    });
    root.querySelector('[data-sph-total]').textContent=total?money(total):'\u2013';
    root.querySelector('[data-sph-count]').textContent=n+' Artikel';
    root.querySelector('[data-sph-addall]').disabled=n<2;
  }

  root.addEventListener('change',function(e){
    if(e.target.hasAttribute&&e.target.hasAttribute('data-sph-qty')){
      var row=e.target.closest('[data-sph-item]');
      var cb=row&&row.querySelector('[data-sph-cb]');
      if(cb&&!cb.checked)cb.checked=true;
    }
    update();
  });

  root.querySelector('[data-sph-addall]').addEventListener('click',function(){
    var btn=this,items=[];
    rows().forEach(function(r){
      var cb=r.querySelector('[data-sph-cb]'),v=r.querySelector('[data-sph-var]');
      if(cb&&cb.checked&&v&&v.value)items.push({id:parseInt(v.value,10),quantity:qtyOf(r)});
    });
    if(!items.length)return;
    btn.disabled=true;btn.textContent='Wird hinzugef\u00fcgt \u2026';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){btn.disabled=false;btn.textContent='Erneut versuchen';});
  });

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.sph-cart');
  if(!root)return;

  function post(url,body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
  }
  function reload(){ window.location.reload(); }

  root.addEventListener('click',function(e){
    var q=e.target.closest('[data-sph-qty]');
    if(q){
      var to=parseInt(q.getAttribute('data-to'),10);
      post('/cart/change.js',{id:q.getAttribute('data-sph-qty'),quantity:Math.max(0,to)}).then(reload);
      return;
    }
    var rm=e.target.closest('[data-sph-remove]');
    if(rm){
      post('/cart/change.js',{id:rm.getAttribute('data-sph-remove'),quantity:0}).then(reload);
      return;
    }
    var add=e.target.closest('[data-sph-upadd]');
    if(add){
      var card=add.closest('.sph-up');
      var v=card.querySelector('[data-sph-upvar]');
      if(!v||!v.value)return;
      add.disabled=true;add.textContent='Wird hinzugef\u00fcgt \u2026';
      post('/cart/add.js',{items:[{id:parseInt(v.value,10),quantity:1}]}).then(reload);
    }
  });

  root.addEventListener('change',function(e){
    var i=e.target.closest('[data-sph-input]');
    if(i){
      var n=parseInt(i.value,10);
      if(isNaN(n)||n<0)n=1;
      post('/cart/change.js',{id:i.getAttribute('data-sph-input'),quantity:n}).then(reload);
    }
  });

  var note=root.querySelector('[data-sph-note]');
  if(note){
    var t;
    note.addEventListener('input',function(){
      clearTimeout(t);
      t=setTimeout(function(){ post('/cart/update.js',{note:note.value}); },600);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-collection"]) return;
  try {
    
(function(){
  var root=document.querySelector('[data-sph-coll]');
  if(!root)return;
  var grid=root.querySelector('[data-sph-grid]');
  var cards=Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
  var chips=root.querySelector('[data-sph-chips]');
  var count=root.querySelector('[data-sph-count]');
  var empty=root.querySelector('[data-sph-empty]');
  var resetBtn=root.querySelector('[data-sph-reset]');
  var sortSel=root.querySelector('[data-sph-sort]');
  var boxes=Array.prototype.slice.call(root.querySelectorAll('.sph-fopt input'));
  var KEYS={st:'st',mat:'mat',far:'far',str:'str'};
  function selected(){
    var s={st:[],mat:[],far:[],str:[]};
    boxes.forEach(function(b){ if(b.checked) s[b.getAttribute('data-f')].push(b.value); });
    return s;
  }
  function writeUrl(s){
    var u=new URL(window.location.href);
    Object.keys(KEYS).forEach(function(k){
      if(s[k].length) u.searchParams.set(k,s[k].join(',')); else u.searchParams.delete(k);
    });
    var sv=sortSel?sortSel.value:'manual';
    if(sv!=='manual') u.searchParams.set('sort',sv); else u.searchParams.delete('sort');
    history.replaceState(null,'',u.toString());
  }
  function apply(){
    var s=selected(), shown=0;
    cards.forEach(function(c){
      var ok=Object.keys(KEYS).every(function(k){
        if(!s[k].length)return true;
        return s[k].indexOf(c.getAttribute('data-'+k))!==-1;
      });
      c.hidden=!ok;
      if(ok)shown++;
    });
    count.textContent=shown;
    empty.hidden=shown!==0;
    chips.textContent='';
    var any=false;
    boxes.forEach(function(b){
      if(!b.checked)return;
      any=true;
      var label=b.parentNode.querySelector('span:last-child').textContent;
      var btn=document.createElement('button');
      btn.type='button';btn.className='sph-chip';
      btn.appendChild(document.createTextNode(label+' '));
      var xb=document.createElement('b');
      xb.textContent='\u00d7';
      btn.appendChild(xb);
      btn.addEventListener('click',function(){ b.checked=false; sync(); });
      chips.appendChild(btn);
    });
    resetBtn.hidden=!any;
    root.querySelectorAll('.sph-fdd').forEach(function(d){
      var n=d.querySelectorAll('input:checked').length;
      var em=d.querySelector('summary em');
      d.classList.toggle('is-on',n!==0);
      if(em){ em.hidden=n===0; em.textContent=n; }
    });
    writeUrl(s);
  }
  function sortNow(){
    var mode=sortSel?sortSel.value:'manual';
    var arr=cards.slice();
    arr.sort(function(a,b){
      if(mode==='price-asc')return a.dataset.price-b.dataset.price;
      if(mode==='price-desc')return b.dataset.price-a.dataset.price;
      if(mode==='title-asc')return a.dataset.title.localeCompare(b.dataset.title,'de');
      if(mode==='title-desc')return b.dataset.title.localeCompare(a.dataset.title,'de');
      return a.dataset.i-b.dataset.i;
    });
    arr.forEach(function(c){ grid.appendChild(c); });
    grid.appendChild(empty);
  }
  function sync(){ apply(); }
  boxes.forEach(function(b){ b.addEventListener('change',sync); });
  if(sortSel) sortSel.addEventListener('change',function(){ sortNow(); apply(); });
  resetBtn.addEventListener('click',function(){ boxes.forEach(function(b){b.checked=false;}); sync(); });
  var r2=root.querySelector('[data-sph-reset2]');
  if(r2) r2.addEventListener('click',function(){ boxes.forEach(function(b){b.checked=false;}); sync(); });
  document.addEventListener('click',function(e){
    root.querySelectorAll('.sph-fdd[open]').forEach(function(d){
      if(!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  var u=new URL(window.location.href);
  Object.keys(KEYS).forEach(function(k){
    var raw=u.searchParams.get(k);
    if(!raw)return;
    var vals=raw.split(',');
    boxes.forEach(function(b){
      if(b.getAttribute('data-f')!==k)return;
      if(vals.indexOf(b.value)!==-1) b.checked=true;
    });
  });
  if(sortSel){
    var so=u.searchParams.get('sort');
    if(so) sortSel.value=so;
  }
  sortNow();
  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-cutdach"]) return;
  try {
    
(function(){
  var box=document.querySelector('[data-sph-dcut]');
  if(!box)return;

  var buy=document.querySelector('[data-sph-product] .sph-buy');
  if(buy&&buy.parentNode)buy.parentNode.insertBefore(box,buy);

  var form=document.querySelector('form[action*="/cart/add"]');
  var w=box.querySelector('[data-sph-w]'), wr=box.querySelector('[data-sph-wr]');
  var d=box.querySelector('[data-sph-d]'), dr=box.querySelector('[data-sph-dr]');
  var sum=box.querySelector('[data-sph-dsum]');
  var touched={w:false,d:false};

  function setProp(name,value){
    if(!form)return;
    var el=form.querySelector('input[name="properties['+name+']"]');
    if(!value){ if(el)el.remove(); return; }
    if(!el){ el=document.createElement('input'); el.type='hidden'; el.name='properties['+name+']'; form.appendChild(el); }
    el.value=value;
  }

  function clamp(input){
    var v=parseInt(input.value,10);
    var min=parseInt(input.min,10), max=parseInt(input.max,10);
    if(isNaN(v))return null;
    return Math.min(max,Math.max(min,v));
  }

  function paint(range){
    var min=parseInt(range.min,10), max=parseInt(range.max,10), v=parseInt(range.value,10);
    var pct=((v-min)/(max-min))*100;
    range.style.background='linear-gradient(90deg,var(--sph-red) 0%,var(--sph-red) '+pct+'%,var(--sph-g100) '+pct+'%,var(--sph-g100) 100%)';
  }

  function sync(){
    var screw=box.querySelector('input[name="sph-screw"]:checked');
    var sym=box.querySelector('input[name="sph-sym"]:checked');
    var wv=clamp(w), dv=clamp(d);

    setProp('Schrauben', screw?screw.value:'');
    setProp('Symmetrie', sym?sym.value:'');
    setProp('Dachbreite', touched.w&&wv?wv+' mm':'');
    setProp('Dachtiefe', touched.d&&dv?dv+' mm':'');

    paint(wr); paint(dr);

    var parts=[];
    if(touched.w&&wv)parts.push('Breite <b>'+wv+' mm</b>');
    if(touched.d&&dv)parts.push('Tiefe <b>'+dv+' mm</b>');
    if(screw)parts.push(screw.value);
    if(sym)parts.push(sym.value);
    if(parts.length){ sum.hidden=false; sum.innerHTML='Ihr Zuschnitt: '+parts.join(' \u00b7 '); }
    else sum.hidden=true;
  }

  wr.addEventListener('input',function(){ w.value=wr.value; touched.w=true; sync(); });
  dr.addEventListener('input',function(){ d.value=dr.value; touched.d=true; sync(); });
  w.addEventListener('input',function(){ touched.w=true; var v=clamp(w); if(v!==null)wr.value=v; sync(); });
  d.addEventListener('input',function(){ touched.d=true; var v=clamp(d); if(v!==null)dr.value=v; sync(); });
  w.addEventListener('blur',function(){ var v=clamp(w); if(v!==null)w.value=v; sync(); });
  d.addEventListener('blur',function(){ var v=clamp(d); if(v!==null)d.value=v; sync(); });
  box.addEventListener('change',sync);

  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-sph-revslider]');
  if(!root)return;
  var track=root.querySelector('[data-rev-track]');
  if(!track)return;
  function step(){var c=track.querySelector('.sph-rev');return c?c.getBoundingClientRect().width+24:320;}
  function go(dir){
    var max=track.scrollWidth-track.clientWidth;
    var next=track.scrollLeft+dir*step();
    if(dir>0&&track.scrollLeft>=max-4)next=0;
    if(dir<0&&track.scrollLeft<=4)next=max;
    track.scrollTo({left:next,behavior:'smooth'});
  }
  var prev=root.querySelector('[data-rev-prev]');
  var next=root.querySelector('[data-rev-next]');
  if(prev)prev.addEventListener('click',function(){go(-1);});
  if(next)next.addEventListener('click',function(){go(1);});
  var timer=setInterval(function(){go(1);},6000);
  ['pointerenter','touchstart','focusin'].forEach(function(ev){
    root.addEventListener(ev,function(){clearInterval(timer);timer=null;},{once:true});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-sample"]) return;
  try {
    
(function(){
  var flag=document.querySelector('[data-sph-plate]');
  var isPlate=flag && flag.getAttribute('data-sph-plate')==='1';

  if(!isPlate){
    ['.sph-cut','.sph-cutbox','[data-sph-cut]','[class*="sph-cut"]'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){ el.remove(); });
    });
  }

  var box=document.querySelector('[data-sph-sample]');
  if(!box)return;
  var buy=document.querySelector('[data-sph-product] .sph-buy');
  if(buy&&buy.parentNode)buy.parentNode.insertBefore(box,buy.nextSibling);

  var btn=box.querySelector('[data-sph-samplebtn]');
  var sampleId=parseInt(box.getAttribute('data-variant'),10);
  var max=parseInt(box.getAttribute('data-max'),10)||3;

  btn.addEventListener('click',function(){
    var label=btn.querySelector('span'), old=label.textContent;
    btn.disabled=true; label.textContent='Wird hinzugef\u00fcgt \u2026';

    fetch('/cart.js',{headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var items=cart.items||[];
        var samples=0, already=false;
        items.forEach(function(it){
          if(it.variant_id===sampleId){
            samples+=it.quantity;
            if(it.properties && it.properties['Muster f\u00fcr']===box.getAttribute('data-title')) already=true;
          }
        });

        if(already){ btn.disabled=false; label.textContent='Bereits im Warenkorb'; return null; }
        if(samples>=max){ btn.disabled=false; label.textContent='Max. '+max+' Muster'; return null; }

        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:sampleId,quantity:1,properties:{
            'Muster f\u00fcr':box.getAttribute('data-title'),
            '_bild':box.getAttribute('data-img'),
            '_url':box.getAttribute('data-url')
          }}]})})
          .then(function(){ window.location.href='/cart'; });
      })
      .catch(function(){ btn.disabled=false; label.textContent=old; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
